import { render } from "./legoStepItem.vue?vue&type=template&id=1229060a"
import script from "./legoStepItem.vue?vue&type=script&lang=js"
export * from "./legoStepItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/lego-component/components/boxes/legoStepBox/legoStepItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1229060a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1229060a', __exports__)) {
    api.reload('1229060a', __exports__)
  }
  
  module.hot.accept("./legoStepItem.vue?vue&type=template&id=1229060a", () => {
    api.rerender('1229060a', render)
  })

}


export default __exports__